module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Scholarship_Creation_03-a3671877aaabcdbae701e734417a6579.jpg";